KMVP.kmcQuoteCommon = {
    showQuoteConfirmation: function(confirmationTemplate) {
        window.scrollTo(0, 0);
        $('.kmc-quote-detail-confirmation').html(confirmationTemplate);
        $('.kmc-quote-detail-page').addClass('show-quote-confirmation');
    }
};
